module.exports = ".replay-table-td-pb-10 {\n  padding-bottom: 10px; }\n\n.replay-table-td-pl-10 {\n  padding-left: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/channel/configure/configure.component.scss
// module id = ./src/app/modules/channel/configure/configure.component.scss
// module chunks = main